WiseMetering.Views.EditWiseApiIntegration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/wise_api/edit',
    title: () => i18next.t('modal.title.integrations.edit')
});
